import { useEffect, useState } from 'react';
import { FeaturesFlag } from 'src/hooks/useRemoteConfig/types';
import { useRemoteConfig } from 'src/hooks/useRemoteConfig/useRemoteConfig';

const cache = new Map<keyof FeaturesFlag, boolean>();

export const getIsActiveFeature = (key: keyof FeaturesFlag): boolean | undefined => cache.get(key);
/**
 * If return undefined, it means the feature is loading, show skeleton or any other loading state
 * @param key
 * returns boolean | undefined
 * */
export const useIsActiveFeature = (key: keyof FeaturesFlag): boolean | undefined => {
  const { isActiveFeature } = useRemoteConfig();
  const [isEnabled, setIsEnabled] = useState<boolean | undefined>(cache.get(key));

  useEffect(() => {
    if (typeof isEnabled === 'boolean') return;

    (async () => {
      const value = await isActiveFeature(key);
      cache.set(key, value);
      setIsEnabled(value);
    })();
  }, [key, isEnabled, isActiveFeature]);

  return isEnabled;
};
